import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "title"
};
const _hoisted_2 = {
  key: 0,
  style: {
    "font-weight": "700"
  }
};
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = {
  class: "question"
};
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
  class: "answer"
};
const _hoisted_7 = {
  class: "words-box"
};
const _hoisted_8 = ["onMousedown", "onTouchstart", "innerHTML"];
const _hoisted_9 = ["innerHTML"];
const _hoisted_10 = ["innerHTML"];
const _hoisted_11 = {
  key: 0
};
const _hoisted_12 = ["id", "innerHTML", "onMousedown", "onTouchstart"];
const _hoisted_13 = {
  class: "scroll-button",
  style: {
    "left": "10px"
  }
};
const _hoisted_14 = {
  class: "scroll-button",
  style: {
    "right": "10px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
    class: "mm",
    id: "mm_drag",
    onTouchstart: _cache[0] || (_cache[0] = $event => $setup.touchSwitch = true),
    onMousemove: _cache[1] || (_cache[1] = (...args) => $setup.moveQuestion && $setup.moveQuestion(...args)),
    onTouchmove: _cache[2] || (_cache[2] = (...args) => $setup.moveQuestion && $setup.moveQuestion(...args))
  }, [_createElementVNode("div", _hoisted_1, [$props.questionInfo.skill == 'S1' || $props.questionInfo.skill == 'S2' ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString($props.questionInfo.itemName), 1)) : _createCommentVNode("", true), _createElementVNode("p", {
    innerHTML: $props.questionInfo.itemInstruction
  }, null, 8, _hoisted_3)]), _createElementVNode("div", _hoisted_4, [_renderSlot(_ctx.$slots, "default"), _createElementVNode("div", {
    class: "question-text",
    innerHTML: $setup.itemText
  }, null, 8, _hoisted_5), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.questionItem, (answerItem, answerIndex) => {
    return _openBlock(), _createElementBlock("div", {
      key: 'answer' + answerIndex
    }, [_withDirectives(_createElementVNode("p", {
      onMousedown: e => {
        $setup.setQuestion(e, answerItem);
      },
      onTouchstart: e => {
        $setup.setQuestion(e, answerItem);
      },
      innerHTML: answerItem.text
    }, null, 40, _hoisted_8), [[_vShow, answerItem.isShow]]), _withDirectives(_createElementVNode("p", {
      class: "used",
      innerHTML: answerItem.text
    }, null, 8, _hoisted_9), [[_vShow, !answerItem.isShow]])]);
  }), 128))])])]), _withDirectives(_createElementVNode("span", {
    class: "mm-move",
    id: "mm_dragMove",
    style: _normalizeStyle({
      top: $setup.moveingItem.top + 'px',
      left: $setup.moveingItem.left + 'px'
    }),
    innerHTML: $setup.moveingItem.text
  }, null, 12, _hoisted_10), [[_vShow, !$setup.moveingItem.isShow]]), $setup.isMountedOver ? (_openBlock(), _createElementBlock("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.questionInfo.questionGroupList[0].questionList, (questionListItem, i) => {
    return _openBlock(), _createBlock(_Teleport, {
      key: 'questionBox' + i,
      to: '.questionBox' + i
    }, [_createElementVNode("p", {
      class: _normalizeClass($setup.positionIndex == i && $setup.distance[i] && $setup.distance[i] <= 250000 ? 'questionBox questionBox-hover' : 'questionBox')
    }, [_createElementVNode("span", {
      id: questionListItem.questionId,
      innerHTML: $setup.answer[questionListItem.questionId] ? $setup.questionItem[$setup.answer[questionListItem.questionId].charCodeAt() - 65].text : ' ',
      onMousedown: e => {
        $setup.setQuestionFromAnswer(e, questionListItem.questionId);
      },
      onTouchstart: e => {
        $setup.setQuestionFromAnswer(e, questionListItem.questionId);
      }
    }, null, 40, _hoisted_12)], 2)], 8, ["to"]);
  }), 128))])) : _createCommentVNode("", true)], 32), (_openBlock(), _createBlock(_Teleport, {
    to: "#app"
  }, [_withDirectives(_createElementVNode("div", _hoisted_13, [_createElementVNode("div", {
    class: "up",
    onTouchstart: _cache[3] || (_cache[3] = $event => $setup.scrollMove('question-text', -100)),
    onTouchend: _cache[4] || (_cache[4] = $event => $setup.scrollMove('question-text', 0))
  }, [_createVNode(_component_el_button, {
    style: {
      "background": "none",
      "border": "none",
      "padding": "0",
      "font-size": "20px",
      "color": "#fff"
    },
    icon: $setup.ArrowUp,
    size: "large"
  }, null, 8, ["icon"])], 32), _createElementVNode("div", {
    class: "down",
    onTouchstart: _cache[5] || (_cache[5] = $event => $setup.scrollMove('question-text', 100)),
    onTouchend: _cache[6] || (_cache[6] = $event => $setup.scrollMove('question-text', 0))
  }, [_createVNode(_component_el_button, {
    style: {
      "background": "none",
      "border": "none",
      "padding": "0",
      "font-size": "20px",
      "color": "#fff"
    },
    icon: $setup.ArrowDown,
    size: "large"
  }, null, 8, ["icon"])], 32)], 512), [[_vShow, $setup.touchSwitch]]), _withDirectives(_createElementVNode("div", _hoisted_14, [_createElementVNode("div", {
    class: "up",
    onTouchstart: _cache[7] || (_cache[7] = $event => $setup.scrollMove('answer', -100)),
    onTouchend: _cache[8] || (_cache[8] = $event => $setup.scrollMove('answer', 0))
  }, [_createVNode(_component_el_button, {
    style: {
      "background": "none",
      "border": "none",
      "padding": "0",
      "font-size": "20px",
      "color": "#fff"
    },
    icon: $setup.ArrowUp,
    size: "large"
  }, null, 8, ["icon"])], 32), _createElementVNode("div", {
    class: "down",
    onTouchstart: _cache[9] || (_cache[9] = $event => $setup.scrollMove('answer', 100)),
    onTouchend: _cache[10] || (_cache[10] = $event => $setup.scrollMove('answer', 0))
  }, [_createVNode(_component_el_button, {
    style: {
      "background": "none",
      "border": "none",
      "padding": "0",
      "font-size": "20px",
      "color": "#fff"
    },
    icon: $setup.ArrowDown,
    size: "large"
  }, null, 8, ["icon"])], 32)], 512), [[_vShow, $setup.touchSwitch]])]))], 64);
}